import { lazy, Suspense } from 'react';
import { Routes, Route } from 'react-router-dom';
import LanguageRedirect from './LanguageRedirect';

// Lazy-load pages so only the current route is in the initial bundle
const HomePage = lazy(() => import('../pages/HomePage'));
const ProductsPage = lazy(() => import('../pages/ProductsPage'));
const ProductDetailPage = lazy(() => import('../pages/ProductDetailPage'));
const ServicesPage = lazy(() => import('../pages/ServicesPage'));
const ServiceDetailPage = lazy(() => import('../pages/ServiceDetailPage'));
const CompaniesPage = lazy(() => import('../pages/CompaniesPage'));
const ContactsPage = lazy(() => import('../pages/ContactsPage'));
const SupportPage = lazy(() => import('../pages/SupportPage'));
const TermsPage = lazy(() => import('../pages/TermsPage'));
const PrivacyPage = lazy(() => import('../pages/PrivacyPage'));
const NotFoundPage = lazy(() => import('../pages/NotFoundPage'));

const PageLoader = () => (
  <div className="app-loading" aria-hidden>
    <div className="loading-spinner" />
  </div>
);

const LanguageRoutes = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <Routes>
      {/* Root redirect */}
      <Route path="/" element={<LanguageRedirect />} />
      
      {/* Language-specific routes */}
      <Route path="/:lang" element={<HomePage />} />
      
      {/* Products routes */}
      <Route path="/:lang/produkti" element={<ProductsPage />} />
      <Route path="/:lang/produkti/:productSlug" element={<ProductDetailPage />} />
      <Route path="/:lang/products" element={<ProductsPage />} />
      <Route path="/:lang/products/:productSlug" element={<ProductDetailPage />} />
      <Route path="/:lang/produkciya" element={<ProductsPage />} />
      <Route path="/:lang/produkciya/:productSlug" element={<ProductDetailPage />} />
      <Route path="/:lang/tooted" element={<ProductsPage />} />
      <Route path="/:lang/tooted/:productSlug" element={<ProductDetailPage />} />
      <Route path="/:lang/produktai" element={<ProductsPage />} />
      <Route path="/:lang/produktai/:productSlug" element={<ProductDetailPage />} />
      
      {/* Services routes */}
      <Route path="/:lang/serviss" element={<ServicesPage />} />
      <Route path="/:lang/serviss/:serviceSlug" element={<ServiceDetailPage />} />
      <Route path="/:lang/services" element={<ServicesPage />} />
      <Route path="/:lang/services/:serviceSlug" element={<ServiceDetailPage />} />
      <Route path="/:lang/servis" element={<ServicesPage />} />
      <Route path="/:lang/servis/:serviceSlug" element={<ServiceDetailPage />} />
      <Route path="/:lang/teenused" element={<ServicesPage />} />
      <Route path="/:lang/teenused/:serviceSlug" element={<ServiceDetailPage />} />
      <Route path="/:lang/paslaugos" element={<ServicesPage />} />
      <Route path="/:lang/paslaugos/:serviceSlug" element={<ServiceDetailPage />} />
      
      {/* Companies routes */}
      <Route path="/:lang/mūsu_kompānijas" element={<CompaniesPage />} />
      <Route path="/:lang/our-companies" element={<CompaniesPage />} />
      <Route path="/:lang/nashi-kompanii" element={<CompaniesPage />} />
      <Route path="/:lang/meie-ettevotted" element={<CompaniesPage />} />
      <Route path="/:lang/musu-imones" element={<CompaniesPage />} />
      
      {/* Contacts routes */}
      <Route path="/:lang/kontakti" element={<ContactsPage />} />
      <Route path="/:lang/contacts" element={<ContactsPage />} />
      <Route path="/:lang/kontakty" element={<ContactsPage />} />
      <Route path="/:lang/kontaktid" element={<ContactsPage />} />
      <Route path="/:lang/kontaktai" element={<ContactsPage />} />
      
      {/* Support routes */}
      <Route path="/:lang/mes-atbalstam" element={<SupportPage />} />
      <Route path="/:lang/we-support" element={<SupportPage />} />
      <Route path="/:lang/my-podderzhivaem" element={<SupportPage />} />
      <Route path="/:lang/me-toetame" element={<SupportPage />} />
      <Route path="/:lang/mes-remiame" element={<SupportPage />} />
      
      {/* Terms routes */}
      <Route path="/:lang/lietosanas-noteikumi" element={<TermsPage />} />
      <Route path="/:lang/terms-and-conditions" element={<TermsPage />} />
      <Route path="/:lang/usloviya-ispolzovaniya" element={<TermsPage />} />
      <Route path="/:lang/kasutustingimused" element={<TermsPage />} />
      <Route path="/:lang/naudojimo-salygos" element={<TermsPage />} />
      
      {/* Privacy routes */}
      <Route path="/:lang/privatum-politika" element={<PrivacyPage />} />
      <Route path="/:lang/privacy-policy" element={<PrivacyPage />} />
      <Route path="/:lang/politika-konfidentsialnosti" element={<PrivacyPage />} />
      <Route path="/:lang/privaatsuspoliitika" element={<PrivacyPage />} />
      <Route path="/:lang/privatumo-politika" element={<PrivacyPage />} />
      
      {/* 404 route */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
    </Suspense>
  );
};

export default LanguageRoutes;
